import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearnerSide.vue?vue&type=template&id=45bed124"
import script from "./EnacAtplDashboardPhaseLearnerSide.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearnerSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports